import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import { BASE_URL } from '../../../config/axios';
import { handleErrorToast } from '../../CustomFunctions';
import { AddwithWhiteCircle } from '../../AllSvg';
import { Modal } from 'react-bootstrap';

const AddDescription = ({ idDescription, descriptionList, i, getData, descriptionType, projectId, usedFor }) => {

    const [formData, setFormData] = useState({
        project: projectId,
        description: [],
    });

    const [show, setShow] = useState(false);

    useEffect(() => {
        setFormData(prev => ({ ...prev, project: projectId }));
    }, [projectId]);

    const handleShow = () => {
        setShow(true);
        if (descriptionList && descriptionList.length > 0) {
            setFormData({
                project: projectId,
                description: descriptionList.map((item) => (item))
            })
        }

    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            project: projectId,
            description: [],
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDescriptionChange = (id, field, value) => {
        setFormData((prev) => ({
            ...prev,
            description: prev.description.map((entry) =>
                entry.id === id ? { ...entry, [field]: value } : entry
            ),
        }));
    };

    const handleAddDescription = () => {
        const newEntry = {
            id: uuidv4(),
            description_type: descriptionType,
            description_name: "",
            description_details: "",
        };

        setFormData((prevData) => ({
            ...prevData,
            description: [...prevData.description, newEntry],
        }));
    };

    const handleRemoveDescription = (id) => {
        setFormData((prev) => ({
            ...prev,
            description: prev.description.filter((entry) => entry.id !== id),
        }));
    };

    const [errors, setErrors] = useState({});


    const validateForm = () => {
        const newErrors = {};
        if (formData.description.length === 0) {
            newErrors.description = "At least one description is required!";
        } else {
            const descriptionErrors = [];

            formData.description.forEach((entry, index) => {
                const entryErrors = {};

                if (!entry.description_name || entry.description_name.trim() === "") {
                    entryErrors.description_name = `Description ${index + 1}: Name is required!`;
                }
                if (!entry.description_details || entry.description_details.trim() === "") {
                    entryErrors.description_details = `Description ${index + 1}: Details is required!`;
                }

                if (Object.keys(entryErrors).length > 0) {
                    descriptionErrors[index] = entryErrors;
                }
            });

            if (descriptionErrors.length > 0) {
                newErrors.description = descriptionErrors;
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic
            try {
                let res;
                if (descriptionList && descriptionList.length > 0) {
                    res = await axios.put(`${BASE_URL}/siteproject/description/${idDescription?.[0]}/`, formData);

                }
                else {
                    res = await axios.post(`${BASE_URL}/siteproject/description/`, formData);
                }

                if (res.status === 201 || res.status === 200) {
                    window.location.reload();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    console.log(formData, "formDataDescription")

    console.log(idDescription, "idDescription");

    // return (
    //     <div>
    //         <button title="Add Site Designation" className="upload-svg" onClick={handleShow}>
    //             <AddwithWhiteCircle />
    //             {" "}{usedFor} Description
    //         </button>
    //         <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
    //             <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
    //                 <Modal.Title>Add {usedFor} Description</Modal.Title>

    //             </Modal.Header>
    //             <Modal.Body>

    //                 <div>
    //                     <div className="parent-div">
    //                         <div style={{ width: "100%" }} className='flex-row justify-end'>

    //                             <button className='upload-svg' onClick={handleAddDescription}>+ Add Description</button>
    //                         </div>

    //                         {formData.description.map((entry, index) => (
    //                             <div key={entry.id} style={{ border: "1px solid #ccc", padding: "8px", marginTop: "8px" }}>
    //                                 <div className="flex-column">
    //                                     <input
    //                                         placeholder="Description Short Name (Example: Description 1)"
    //                                         value={entry.description_name}
    //                                         onChange={(e) => handleDescriptionChange(entry.id, "description_name", e.target.value)}
    //                                         className={`form-input ${Array.isArray(errors.description) && errors.description[index]?.description_name ? "error-border" : ""}`}
    //                                     />
    //                                     {Array.isArray(errors.description) && errors.description[index]?.description_name && (
    //                                         <span className="error-message font-size-text">
    //                                             {errors.description[index].description_name}
    //                                         </span>
    //                                     )}
    //                                 </div>
    //                                 <div className="flex-column">

    //                                     <textarea
    //                                         placeholder="Description Details"
    //                                         value={entry.description_details}
    //                                         onChange={(e) => handleDescriptionChange(entry.id, "description_details", e.target.value)}
    //                                         className={`form-input-textarea ${Array.isArray(errors.description) && errors.description[index]?.description_name ? "error-border" : ""}`}

    //                                     />
    //                                     {Array.isArray(errors.description) && errors.description[index]?.description_details && (
    //                                         <span className="error-message font-size-text">
    //                                             {errors.description[index].description_details}
    //                                         </span>
    //                                     )}
    //                                 </div>
    //                                 {/* Remove button filters out this entry by id */}
    //                                 {formData.description.length > 1 &&
    //                                     <div className='flex-row justify-end' style={{ width: "100%" }}>

    //                                         <button onClick={() => handleRemoveDescription(entry.id)} className='model-button   font-weight500    model-button-delete'>Remove</button>
    //                                     </div>
    //                                 }
    //                             </div>

    //                         ))}

    //                     </div>
    //                     <div className="button-models">
    //                         <button className="model-button   font-weight500  model-button-cancel " type="button" onClick={handleClose}>
    //                             Cancel
    //                         </button>
    //                         <button
    //                             //   type="submit"
    //                             className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
    //                             onClick={handleFormSubmit}
    //                             disabled={loading}
    //                         >
    //                             Add
    //                         </button>
    //                     </div>
    //                 </div>
    //             </Modal.Body>
    //         </Modal>
    //     </div >
    // );



    return (
        <>
            <button
                title={`Add ${usedFor} Description`}
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                {usedFor} Description
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="eb-bulk-modal model-width60vw max-heightModal"
            >
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                            <polyline points="10 9 9 9 8 9" />
                        </svg>
                        Add {usedFor} Description
                        <button className="close-btn" onClick={handleClose}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">
                    <div className="eb-bulk-container">
                        <div className="eb-bulk-content">
                            {/* Add Description Button */}
                            <div className="eb-bulk-actions">
                                <button className="eb-bulk-add-row-btn" onClick={handleAddDescription}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" />
                                        <line x1="12" y1="8" x2="12" y2="16" />
                                        <line x1="8" y1="12" x2="16" y2="12" />
                                    </svg>
                                    Add Description
                                </button>
                            </div>

                            {/* Description Cards */}
                            <div className="eb-description-cards table-box scroll-container-tablesss" style={{ maxHeight: "47vh", minHeight: "47vh" }}>
                                {formData.description.map((entry, index) => (
                                    <div key={entry.id} className="eb-description-card table-box scroll-container-tablesss" style={{ minHeight: "40vh" }}>
                                        <div className="eb-description-card-header">
                                            <span className="eb-description-card-number">#{index + 1}</span>
                                            {formData.description.length > 1 && (
                                                <button
                                                    onClick={() => handleRemoveDescription(entry.id)}
                                                    className="eb-description-remove-btn"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <line x1="18" y1="6" x2="6" y2="18" />
                                                        <line x1="6" y1="6" x2="18" y2="18" />
                                                    </svg>
                                                    Remove
                                                </button>
                                            )}
                                        </div>

                                        <div className="eb-description-card-body">
                                            <div className="eb-description-field">
                                                <label className="eb-bulk-label">Description Name</label>
                                                <input
                                                    placeholder="Enter description short name (Example: Description 1)"
                                                    value={entry.description_name}
                                                    style={{ textAlign: "start" }}
                                                    onChange={(e) => handleDescriptionChange(entry.id, "description_name", e.target.value)}
                                                    className={`eb-bulk-input ${Array.isArray(errors.description) && errors.description[index]?.description_name ? "eb-bulk-input-error" : ""}`}
                                                />
                                                {Array.isArray(errors.description) && errors.description[index]?.description_name && (
                                                    <span className="eb-bulk-error-text">
                                                        {errors.description[index].description_name}
                                                    </span>
                                                )}
                                            </div>

                                            <div className="eb-description-field">
                                                <label className="eb-bulk-label">Description Details</label>
                                                <textarea
                                                    placeholder="Enter detailed description"
                                                    value={entry.description_details}
                                                    onChange={(e) => handleDescriptionChange(entry.id, "description_details", e.target.value)}
                                                    className={`eb-bulk-textarea ${Array.isArray(errors.description) && errors.description[index]?.description_details ? "eb-bulk-input-error" : ""}`}
                                                // rows="3"
                                                />
                                                {Array.isArray(errors.description) && errors.description[index]?.description_details && (
                                                    <span className="eb-bulk-error-text">
                                                        {errors.description[index].description_details}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {formData.description.length === 0 && (
                                    <div className="eb-description-empty">
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5">
                                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                                            <polyline points="14 2 14 8 20 8" />
                                            <line x1="16" y1="13" x2="8" y2="13" />
                                            <line x1="16" y1="17" x2="8" y2="17" />
                                            <polyline points="10 9 9 9 8 9" />
                                        </svg>
                                        <p>No descriptions added yet. Click "Add Description" to get started.</p>
                                    </div>
                                )}
                            </div>

                            {/* Footer Actions */}
                            <div className="eb-bulk-footer-actions">
                                <button
                                    className="eb-bulk-btn eb-bulk-btn-cancel"
                                    type="button"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="eb-bulk-btn eb-bulk-btn-submit"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                    style={{ background: "black" }}
                                >
                                    {loading ? (
                                        <span className="eb-bulk-btn-loader">
                                            <span className="eb-bulk-spinner"></span>
                                            Adding...
                                        </span>
                                    ) : (
                                        <>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                            </svg>
                                            Add
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddDescription;